export default class OAuthService {

    constructor(){

    }

    getToken = new Promise((resolve, reject) => {
        var body_params = new URLSearchParams();
        body_params.append("client_id", process.env.REACT_APP_CLIENT_ID);
        body_params.append("client_secret", process.env.REACT_APP_CLIENT_SECRET);
        body_params.append("response_type", "token");
        body_params.append("grant_type", "client_credentials");

        fetch(process.env.REACT_APP_API_URL + '/oauth/token.json', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: body_params.toString()
        })
        .then(response => {
            if(!response.ok){
                reject({error: {status: response.status, statusText: response.statusText}, resp: response.json()});
            }else{
                resolve(response.json());
            }
        })
        .catch((error) => {
            reject(error);
        });
    });

    getUserToken = (username, password) => {
        return new Promise((resolve, reject) => {
            var body_params = new URLSearchParams();
            body_params.append("client_id", process.env.REACT_APP_CLIENT_ID);
            body_params.append("client_secret", process.env.REACT_APP_CLIENT_SECRET);
            body_params.append("response_type", "token");
            body_params.append("grant_type", "password");
            body_params.append("username", username);
            body_params.append("password", password);
            body_params.append("owner_type", "box_customer");

            fetch(process.env.REACT_APP_API_URL + '/oauth/token.json', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: body_params.toString()
            })
            .then(response => {
                if(!response.ok){
                    reject({error: {status: response.status, statusText: response.statusText}, resp: response.json()});
                }else{
                    resolve(response.json());
                }
            })
            .catch((error) => {
                reject(error);
            });
        });
    }

    getUserInfo = (token) => {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_API_URL + '/api/v4/box_customers/me', {
                method: 'GET',
                headers: {
                    Authorization: "Bearer " + token
                }
            })
            .then(async response => {
                if (!response.ok) {
                    const err = await response.json();
                    reject(err);
                } else {
                    resolve(await response.json());
                }
            })
            .catch(error => reject(error));
        });
    }

    getBoxObjects = (token, object_url, new_page, page_size) => {
        new_page = new_page || 1;
        page_size = page_size || 20;
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_API_URL + object_url + '?page=' + new_page + '&page_size=' + page_size, {
                method: 'GET',
                headers: {
                    Authorization: "Bearer " + token
                }
            })
            .then(async response => {
                if (!response.ok) {
                    const err = await response.json();
                    reject(err);
                } else {
                    resolve(await response.json());
                }
            })
            .catch(error => reject(error));
        });
    }

    getBoxJobs = (token, new_page, page_size) => {
        new_page = new_page || 1;
        page_size = page_size || 20;
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_API_URL + '/api/v4/box_jobs/box_jobs?page=' + new_page + '&page_size=' + page_size, {
                method: 'GET',
                headers: {
                    Authorization: "Bearer " + token
                }
            })
            .then(async response => {
                if (!response.ok) {
                    const err = await response.json();
                    reject(err);
                } else {
                    resolve(await response.json());
                }
            })
            .catch(error => reject(error));
        });
    }

    getBoxOrders = (token) => {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_API_URL + '/api/v4/box_jobs/box_orders', {
                method: 'GET',
                headers: {
                    Authorization: "Bearer " + token
                }
            })
            .then(async response => {
                if (!response.ok) {
                    const err = await response.json();
                    reject(err);
                } else {
                    resolve(await response.json());
                }
            })
            .catch(error => reject(error));
        });
    }

    validateBoxConfiguration = (token, box_configuration_id, qty, order_number) => {
        return new Promise((resolve, reject) => {
            fetch(`${process.env.REACT_APP_API_URL}/api/v4/box_configurations/${box_configuration_id}/validate?qty=${qty}&order_number=${order_number}`, {
                method: 'GET',
                headers: {
                    Authorization: "Bearer " + token
                }
            })
           .then(async response => {
                if (!response.ok) {
                    const err = await response.json();
                    reject(err);
                } else {
                    resolve(await response.json());
                }
            })
            .catch(error => reject(error));
        });
    }

    changePassword = (token, currentPassword, newPassword, newPasswordConfirmation) => {
        return new Promise((resolve, reject) => {
            const body = {
                box_customer: {
                    current_password: currentPassword,
                    password: newPassword,
                    password_confirmation: newPasswordConfirmation
                }
            };
            fetch(`${process.env.REACT_APP_API_URL}/api/v4/box_customers/change_password`, {
                method: 'PUT',
                headers: {
                    Authorization: "Bearer " + token,
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                },
                body: JSON.stringify(body)
            })
            .then(async response => {
                if (!response.ok) {
                    const err = await response.json().catch(() => ({}));
                    reject({ status: response.status, body: err });
                } else {
                    resolve(await response.json());
                }
            })
            .catch(error => reject(error));
        });
    }

    reserveBoxConfiguration = (token, box_configuration_id, qty, order_number) => {
        return new Promise((resolve, reject) => {
            var body_params = new URLSearchParams();
            body_params.append("qty", qty);
            body_params.append("order_number", order_number);
            body_params.append("box_configuration_id", box_configuration_id);
            fetch(`${process.env.REACT_APP_API_URL}/api/v4/box_configurations/${box_configuration_id}/reserve`, {
                method: 'PUT',
                headers: {
                    Authorization: "Bearer " + token,
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: body_params.toString()
            })
           .then(async response => {
                if (!response.ok) {
                    const err = await response.json();
                    reject(err);
                } else {
                    resolve(await response.json());
                }
            })
            .catch(error => reject(error));
        });
    }

    createBoxJob = (token, box_configuration_id, order_number, qty) => {
        return new Promise((resolve, reject) => {
            var body_params = new URLSearchParams();
            body_params.append("qty", qty);
            body_params.append("order_number", order_number);
            body_params.append("box_configuration_id", box_configuration_id);
            fetch(`${process.env.REACT_APP_API_URL}/api/v4/box_configurations/${box_configuration_id}/box_jobs`, {
                method: 'POST',
                headers: {
                    Authorization: "Bearer " + token,
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: body_params.toString()
            })
           .then(async response => {
                if (!response.ok) {
                    const err = await response.json();
                    reject(err);
                } else {
                    resolve(await response.json());
                }
            })
            .catch(error => reject(error));
        });
    }

    // resendConfirmation = (token) => {
    //     return new Promise((resolve, reject) => {
    //         fetch(process.env.REACT_APP_API_URL + '/api/v4/box_customers/resend_confirmation', {
    //             method: 'GET',
    //             headers: {
    //                 Authorization: "Bearer " + token
    //             }
    //         })
    //         .then(response => {
    //             if(!response.ok){
    //                 reject({error: {status: response.status, statusText: response.statusText}, resp: response.json()});
    //             }else{
    //                 resolve(response.json());
    //             }
    //         })
    //         .catch((error) => {
    //             reject(error);
    //         });
    //     });
    // }

    // Box Configuration Batch API Methods

    getBoxConfigurationBatchReservations = (token) => {
        return new Promise((resolve, reject) => {
            fetch(`${process.env.REACT_APP_API_URL}/api/v4/box_jobs/box_configuration_batch_reservations`, {
                method: 'GET',
                headers: {
                    Authorization: "Bearer " + token
                }
            })
            .then(async response => {
                if (!response.ok) {
                    const err = await response.json();
                    reject(err);
                } else {
                    resolve(await response.json());
                }
            })
            .catch(error => reject(error));
        });
    }

    getBoxConfigurationBatches = (token) => {
        return new Promise((resolve, reject) => {
            fetch(`${process.env.REACT_APP_API_URL}/api/v4/box_configuration_batches`, {
                method: 'GET',
                headers: {
                    Authorization: "Bearer " + token
                }
            })
            .then(async response => {
                if (!response.ok) {
                    const err = await response.json();
                    reject(err);
                } else {
                    resolve(await response.json());
                }
            })
            .catch(error => reject(error));
        });
    }

    createBoxConfigurationBatch = (token, name, batchItems) => {
        return new Promise((resolve, reject) => {
            const body = {
                box_configuration_batch: {
                    name: name,
                    batch_items: batchItems
                }
            };
            fetch(`${process.env.REACT_APP_API_URL}/api/v4/box_configuration_batches`, {
                method: 'POST',
                headers: {
                    Authorization: "Bearer " + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            })
            .then(async response => {
                if (!response.ok) {
                    const err = await response.json();
                    reject(err);
                } else {
                    resolve(await response.json());
                }
            })
            .catch(error => reject(error));
        });
    }

    getBoxConfigurationBatch = (token, batchId) => {
        return new Promise((resolve, reject) => {
            fetch(`${process.env.REACT_APP_API_URL}/api/v4/box_configuration_batches/${batchId}`, {
                method: 'GET',
                headers: {
                    Authorization: "Bearer " + token
                }
            })
            .then(async response => {
                if (!response.ok) {
                    const err = await response.json();
                    reject(err);
                } else {
                    resolve(await response.json());
                }
            })
            .catch(error => reject(error));
        });
    }

    reserveBoxConfigurationBatch = (token, batchId, qty) => {
        return new Promise((resolve, reject) => {
            const body = {
                qty: qty
            };
            fetch(`${process.env.REACT_APP_API_URL}/api/v4/box_configuration_batches/${batchId}/reserve`, {
                method: 'POST',
                headers: {
                    Authorization: "Bearer " + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            })
            .then(async response => {
                if (!response.ok) {
                    const err = await response.json();
                    reject(err);
                } else {
                    resolve(await response.json());
                }
            })
            .catch(error => reject(error));
        });
    }

    deleteBoxConfigurationBatch = (token, batchId) => {
        return new Promise((resolve, reject) => {
            fetch(`${process.env.REACT_APP_API_URL}/api/v4/box_configuration_batches/${batchId}`, {
                method: 'DELETE',
                headers: {
                    Authorization: "Bearer " + token,
                    'Content-Type': 'application/json'
                }
            })
            .then(async response => {
                if (!response.ok) {
                    const err = await response.json();
                    reject(err);
                } else {
                    resolve(await response.json());
                }
            })
            .catch(error => reject(error));
        });
    }

}